import React from "react";
import styled, { withTheme } from "styled-components";
import { ColorUtil } from "../../util/";
import { Colors, Metrics } from "../../theme/index";

const PanelHeader = styled.div`
    padding: 8px 18px;
    font-size:${props=>Metrics.fontSize.header}px;
    font-weight: ${props=>Metrics.heavyFontWeidht};
    ${props=>props.color ? "color:#FFF;" : ""}
    border-radius:${props=>`
        ${Metrics.boldBorderRadius}px ${Metrics.boldBorderRadius}px 0px 0px
    `};
    background-color:${props=>props.color ? props.color : Colors.greyBackgroundColor};
`;
const PanelContent = styled.div`
    padding:${Metrics.padding.panelContainer}px;
    border: 1px solid ${props=>props.color ? props.color : Colors.lightBorderColor};
    border-radius:${props=>`
        0px 0px ${Metrics.boldBorderRadius}px ${Metrics.boldBorderRadius}px
    `}
`;

export const OPanelHeader = withTheme((props)=>{
	const { theme, colorType, header } = props;
	const bgColor = colorType ? ColorUtil.getVisualizeColor(theme, colorType, 0) : undefined;
	return <PanelHeader {...props} color={bgColor}>
		{header}
	</PanelHeader>;
});
export const OPanelContent = withTheme((props)=>{
	const { theme, colorType } = props;
	const bgColor = colorType ? ColorUtil.getVisualizeColor(theme, colorType, 0) : undefined;
	return <PanelContent {...props} color={bgColor}/>;
});

export default ({style, headerStyle,header, colorType, children})=>(
	<div style={style}>
		<OPanelHeader 
			style={headerStyle} 
			header={header} 
			colorType={colorType}/>
		<OPanelContent colorType={colorType}>
			{children}
		</OPanelContent>
	</div>
);


// WEBPACK FOOTER //
// ./src/components/layout/ThemePanel.js